import {getUserLanguage} from '../locale'

export default function formatSymbol(number: number): string {
  const formatter = Intl.NumberFormat(getUserLanguage(), {
    maximumFractionDigits: 2,
    maximumSignificantDigits: 4,
    notation: 'compact',
  })

  return formatter.format(number)
}
